export const defaultOffer = product => ({
  product_id: product.id,
  ...product,
  url: product.url,
  description: "Oferta Padrão do produto",
  name: "Oferta Principal",
  status: product.status,
  price: product.price,
  periodicity: product.periodicity,
  test_days: product.test_days,
  num_max_payments: 1,
  currency: product.currency,
  installments: product.installments,
  smart_installment: product.smart_installment,
  is_main: true,
  id: -1,
  price_usd: product.price_usd || 0,
  price_eur: product.price_eur || 0
});

export const approvalMessageUrl = (product, user) => {
  let number = "5512992588524";
  let text =
    "Olá, estou entrando em contato para solicitar APROVAÇÃO DE PRODUTO. \n\nProduto: " +
    product?.name +
    "\nIdentificador: " +
    product?.code +
    "\nProdutor: " +
    user?.email;
  return "https://wa.me/" + number + "?text=" + encodeURIComponent(text);
};
